import React from "react";
import GoldCoin from "../images/Gold_coin.png";
import SilverCoin from "../images/Silver_coin.png";
import CopperCoin from "../images/Copper_coin.png";
import { copperToCoinParts } from "../utils/coins";

function CoinUnit({ amount, icon, alt }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
      <span style={{ minWidth: 20, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
        {amount}
      </span>
      <img src={icon} alt={alt} style={{ width: 16, height: 16, objectFit: "contain" }} />
    </span>
  );
}

export default function CoinAmount({ value, compact = false, color = "inherit" }) {
  if (value == null) {
    return <span style={{ color }}>-</span>;
  }

  const { gold, silver, copper } = copperToCoinParts(value);

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: compact ? 6 : 10,
        color,
        fontWeight: 600,
        fontSize: compact ? 13 : 14,
      }}
    >
      <CoinUnit amount={gold} icon={GoldCoin} alt="gold" />
      <CoinUnit amount={silver} icon={SilverCoin} alt="silver" />
      <CoinUnit amount={copper} icon={CopperCoin} alt="copper" />
    </span>
  );
}
